import UserProfileMenu from '@/features/auth/user-profile-menu';
import { Link } from '@tanstack/react-router';

import { useCurrentUser } from '@/hooks/useApiKey';
import { useLogout } from '@/hooks/useLogout';
import { useMenu } from '@/hooks/useMenu';

import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    SidebarGroupLabel,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarRail,
} from '@/components/ui/sidebar';

import { Skeleton } from './ui/skeleton';
import UserMenu from './user-menu';

// TODO: Move this out of components and into features
export function AppSidebar() {
    const { menuSections, isLoadingMenu } = useMenu();
    const logout = useLogout({ isSessionExpired: false });

    const [currentUser] = useCurrentUser();

    return (
        <Sidebar collapsible="icon" data-testid="AppSidebar">
            <SidebarHeader>
                <UserMenu />
            </SidebarHeader>

            <SidebarContent className="group-data-[collapsible=icon]:pt-2">
                {isLoadingMenu
                    ? Array.from({ length: 3 }).map((_, idx) => (
                          <SidebarGroup key={idx} className="px-2 py-1">
                              <Skeleton className="h-3 w-16 mb-2 ml-1 rounded" />
                              <SidebarMenu>
                                  {Array.from({ length: idx === 0 ? 4 : 2 }).map((_, i) => (
                                      <SidebarMenuItem key={i}>
                                          <Skeleton className="h-8 w-full rounded-md" />
                                      </SidebarMenuItem>
                                  ))}
                              </SidebarMenu>
                          </SidebarGroup>
                      ))
                    : menuSections.map((section, idx) => (
                          <SidebarGroup key={idx} className="px-2 py-1">
                              <SidebarGroupLabel>{section.name}</SidebarGroupLabel>
                              <SidebarMenu>
                                  {section.menuItems.map((item) => (
                                      <SidebarMenuItem
                                          key={item.title}
                                          data-testid="MenuItems"
                                      >
                                          <SidebarMenuButton
                                              asChild
                                              isActive={item.active}
                                              tooltip={item.title}
                                          >
                                              <Link
                                                  to={item.href}
                                                  data-testid={item.testId}
                                              >
                                                  <item.icon />
                                                  <span>{item.title}</span>
                                                  {item.isBeta && (
                                                      <>
                                                          <span
                                                              className="ml-auto flex h-4 items-center rounded-full bg-orange-100 px-2 text-[9px] font-medium tracking-wide text-orange-700 uppercase group-data-[collapsible=icon]:hidden"
                                                              data-testid={`${item.testId}__betaPill`}
                                                          >
                                                              Beta
                                                          </span>
                                                          {/* The button clips at 32px when collapsed, so the pill
                                                              disappears and only this dot is left to mark it. */}
                                                          <span
                                                              aria-hidden
                                                              className="absolute top-1 right-1 hidden size-2 rounded-full bg-orange-500 group-data-[collapsible=icon]:block"
                                                              data-testid={`${item.testId}__betaDot`}
                                                          />
                                                      </>
                                                  )}
                                              </Link>
                                          </SidebarMenuButton>
                                      </SidebarMenuItem>
                                  ))}
                              </SidebarMenu>
                          </SidebarGroup>
                      ))}
            </SidebarContent>

            <SidebarFooter>
                <UserProfileMenu user={currentUser} onLogout={logout} />
            </SidebarFooter>

            <SidebarRail />
        </Sidebar>
    );
}
